import { createFileRoute } from '@tanstack/react-router';
import { generateValidateSearch } from '@/lib/filters/validate-search';
import { entitiesFilterConfig } from '@/lib/filters/configs/entities-filters';

// Was `(search) => search`, which accepts anything and validates nothing. Declaring the filter
// fields and the `type` tab lets the router keep them across navigations (W4.T6.0).
export const Route = createFileRoute('/entities/')({
  validateSearch: generateValidateSearch(entitiesFilterConfig),
});
